import { useEffect, useState } from "react";

import PercentileSelector, {
  Percentile,
  Str2Percentile,
} from "../../../../K8s/Dashboard/ClusterDetail/Components/PercentileSelector";
import { FilterModeOption } from "../../../allocations/types";
import { useReportDimensionsContext } from "../../../Context";

interface ReportPercentileSelectorProps {
  onChangeReportFilter?: (
    filterId: string,
    type: FilterModeOption,
    value: string[] | string,
    inverse?: boolean
  ) => void;
}

const ReportPercentileSelector = ({ onChangeReportFilter }: ReportPercentileSelectorProps) => {
  const { dimensions = [] } = useReportDimensionsContext();

  const percentileDimension = dimensions?.find((d) => d.id === "fixed:percentile");
  const filterValue = percentileDimension?._filter?.[0];

  const defaultPercentile = !filterValue ? Percentile.P_99 : (Str2Percentile(filterValue) ?? Percentile.P_99);

  const [pvalue, setpValue] = useState<Percentile>(defaultPercentile);

  useEffect(() => {
    if (!filterValue) {
      const convertedPercentile = (parseFloat(pvalue) * 100).toString();
      onChangeReportFilter?.("fixed:percentile", FilterModeOption.IS, [convertedPercentile]);
    }
  }, [filterValue, pvalue, onChangeReportFilter]);

  const handleChange = (p: Percentile) => {
    if (p !== pvalue || !filterValue) {
      setpValue(p);

      const convertedPercentile = (parseFloat(p) * 100).toString();
      onChangeReportFilter?.("fixed:percentile", FilterModeOption.IS, [convertedPercentile]);
    }
  };

  return (
    <PercentileSelector
      value={pvalue}
      onChange={handleChange}
      sx={{ width: "100%" }}
      availableOptions={[Percentile.P_99_9, Percentile.P_99, Percentile.P_95, Percentile.P_90, Percentile.P_80]}
      disabled={!percentileDimension}
      data-cy="report-percentile-selector"
    />
  );
};

export default ReportPercentileSelector;
